import { Badge, Box, Tab, Tabs, Typography, Paper, alpha, Stack, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import PaymentPending from './payment-list/PaymentPending';
import PaymentApproved from './payment-list/PaymentApproved';
import { ConfirmationNumberOutlined, VerifiedUserOutlined } from '@mui/icons-material';

const PaymentScreen = withRouter(({ props }) => {
  const { location, history } = props;
  const searchParams = new URLSearchParams(location?.search);
  const status = searchParams.get('status') || '';

  const [pendingCount, setPendingCount] = useState(0);

  const tabs = [
    {
      value: 'awaiting_approval',
      label: 'Awaiting Confirmation',
      icon: <ConfirmationNumberOutlined sx={{ fontSize: 18 }} />,
      badgeCount: pendingCount,
      component: () => (
        <PaymentPending props={props} onPendingCount={(count) => setPendingCount(count)} />
      ),
    },
    {
      value: 'approved',
      label: 'Confirmed Payments',
      icon: <VerifiedUserOutlined sx={{ fontSize: 18 }} />,
      badgeCount: 0,
      component: () => <PaymentApproved props={props} />,
    },
  ];

  const tabIndex = tabs?.findIndex((x) => x.value === status);
  const activeTabIndex = tabIndex !== -1 ? tabIndex : 0;

  useEffect(() => {
    handleIniSearchParam();
  }, []);

  const handleIniSearchParam = () => {
    if (!status) {
      const newParam = new URLSearchParams(searchParams);
      newParam.set('status', tabs[0].value);
      history.push({ search: newParam.toString() });
    }
  };

  const handleTabChange = (event, val) => {
    const newParam = new URLSearchParams();
    newParam.set('status', tabs[val]?.value);
    history.push({ search: newParam.toString() });
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#F4F6F8', minHeight: '100vh', mt: -1 }}>
      {/* HEADER SECTION */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" fontWeight={700} color="text.primary">
          Payment Management
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Verify payments and track confirmed transactions across the system.
        </Typography>
      </Box>

      {/* NAVIGATION CARD */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: '16px',
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
        }}
      >
        <Box sx={{ px: 2, pt: 1, bgcolor: '#fff' }}>
          <Tabs
            value={activeTabIndex}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              '& .MuiTabs-indicator': { height: 3, borderRadius: '3px 3px 0 0' },
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 700,
                fontSize: '0.875rem',
                minHeight: 52,
                color: 'text.secondary',
                '&.Mui-selected': { color: 'primary.main' },
              },
            }}
          >
            {tabs?.map((tabItem, idx) => (
              <Tab
                key={idx}
                icon={tabItem.icon}
                iconPosition="start"
                label={
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography variant="inherit">{tabItem.label}</Typography>
                    {tabItem.badgeCount > 0 && (
                      <Badge
                        badgeContent={tabItem.badgeCount}
                        color="error"
                        sx={{
                          '& .MuiBadge-badge': {
                            fontSize: '0.65rem',
                            height: 18,
                            minWidth: 18,
                            fontWeight: 700,
                          },
                          ml: 1.5,
                        }}
                      />
                    )}
                  </Stack>
                }
              />
            ))}
          </Tabs>
        </Box>
        <Divider />

        {/* CONTENT AREA */}
        <Box sx={{ p: { xs: 2, md: 3 }, bgcolor: '#fff' }}>{tabs[activeTabIndex]?.component()}</Box>
      </Paper>
    </Box>
  );
});

export default PaymentScreen;
